import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getOrganizationSchemaAdditionalFields,
  organizationSchema,
} from "./organization";
import { personSchema } from "./person";

export const organizationWithContactSchema = organizationSchema.extend({
  contact: personSchema.optional(),
});

export type OrganizationWithContact = z.infer<
  typeof organizationWithContactSchema
>;

export function getOrganizationWithContactSchemaAdditionalFields(additionalFields: {
  organization: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
}): typeof organizationWithContactSchema {
  return organizationWithContactSchema.extend({
    organization: getOrganizationSchemaAdditionalFields(additionalFields),
  });
}
